import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface IState {
  chiNhanhList?: any
  chiNhanhDetail?: any
}

const initialState: IState = {
  chiNhanhList: {},
  chiNhanhDetail: {},
}

export const chiNhanhDucks = createSlice({
  name: 'chiNhanh',
  initialState,
  reducers: {
   
    getListChiNhanh: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: true, queryStr: action.payload }
    },
    getListChiNhanhSuccess: (state, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: false, ...action.payload }
    },
    getListChiNhanhFail: (state, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: false, ...action.payload }
    },
    
    getDetailChiNhanh: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: true, id: action.payload }
    },
    getDetailChiNhanhSuccess: (state, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: false, ...action.payload }
    },
    getDetailChiNhanhFail: (state, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: false, ...action.payload }
    },
    
  },
})

// Action creators are generated for each case reducer function
export const {
  getListChiNhanh,
  getListChiNhanhSuccess,
  getListChiNhanhFail,
  getDetailChiNhanh,
  getDetailChiNhanhSuccess,
  getDetailChiNhanhFail,
} = chiNhanhDucks.actions

export default chiNhanhDucks.reducer 